<template>
  <!-- 목표 달성시 style="display: block;" 추가 -->
  <div class="dashboard-info">
    <div class="dashboard-info__title">
      <h3 class="title">프로모션 혜택을 받은 신규 ABO의 데이터는 익일에 반영됩니다.</h3>
    </div>
    
    <template v-if="noMembers"> 
      <div class="dashboard-info__nodata" >
        <i class="no-data-icon"></i>
        <!-- 가입자 정보가 없을 경우 -->
        <p class="no-data-text">해당 ABO정보가 없습니다.</p>
        
      </div>
    </template>

    <div class="dashboard-info__card v2" v-if="!noMembers">
      <div class="info_table_box">
			  <div class="info_head">
				  <div class="info_head_tit user mo">이름 / 회원번호</div>
					<div class="info_head_tit user pc">이름</div>
					<div class="info_head_tit pc">회원번호</div>
					<div class="info_head_tit promotion">9월 프로모션 증정 결과</div>
					<div class="info_head_tit">
					  장스오
						<ul>
						  <li>9월</li>
							<li>10월</li>
							<li>11월</li>
						</ul>
					</div>
				</div>

        <div class="info_body">
          <div class="info_body_cont" v-for="(abo, index) in abocardlist" :key="index">
            <div class="info_body_txt user mo">
                <span class="num">{{index+1}}</span>
                <div class="userInfo">{{abo.name}} / <span class="aboNum">{{abo.number}}</span></div>
            </div>
            <div class="info_body_txt user pc">
                <span class="num">{{index+1}}</span>
                <div class="userInfo">{{abo.name}}</div>
            </div>
            <div class="info_body_txt pc">{{abo.number}}</div>
            <div class="info_body_txt promotion">{{ abo.amt }}</div>
            <div class="info_body_txt">
              <ul>
                <li><span :class="{orderConfirm: abo.sop.SEP}"></span></li>
                <li><span :class="{orderConfirm: abo.sop.OCT}"></span></li>
                <li><span :class="{orderConfirm: abo.sop.NOV}"></span></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="dashboard-info__notice">
      <p class="notice-title">알아두세요!</p>
      <div class="notice-list">
        <ul>
          <li>후원 현황은 주문 기준이며, 데이터는 익일에 반영됩니다.</li>
          <li>무통장 입금의 경우, 입금이 완료되지 않은 주문 건은 제외됩니다.</li>
          <li>보다 자세한 사항은 프로모션 안내 페이지를 참조하시기 바랍니다.</li>
        </ul>
      </div>
    </div>

    <div class="dashboard-info__banner">
      <a :href="link">
        <img src="../assest/images/dashboard_banner_icon.png"/>신규 ABO 프로모션 <br class="mo"/>공지문 바로가기
      </a>
    </div>
    <!-- E : 20230315 대시보드 업데이트 -->
  </div>
  <!-- // 목표 달성시 style="display: block;" 추가 -->
</template>
<script>
export default {
  props: {
    abocardlist: {
      type: [] ,
      default : [],
      reqired: true
    }, 
    link: { 
      type: String, 
      default: '',
      reqired: true
    }
  },
  computed : { 
    noMembers () { // 신규회원 없음
      return !this.abocardlist || this.abocardlist.length === 0;
    },
  }
}
</script>
<style scoped>
@import '../assest/css/abo.css';
</style>



// WEBPACK FOOTER //
// src/views/sales/dashboard3/component/abocardList.vue